<template>
  <div class="score-announcement flex">
    <div class="item bg1" v-for="item in list" :key="item.teamId || item.id">
      <div class="rank text-center color-white" :style="rankStyle(item)">{{ rankLabel(item) }}</div>
      <div class="team vertical-center">
        <img :src="imgView(item.badge)" v-if="item.badge" />
        <span class="overflow-text font-color2">{{ item.name }}</span>
      </div>
      <div class="score flex">
        <div class="score-item">
          <div class="round text-center color-white" :style="rankStyle(item)">{{ item.winRound }}</div>
          <div>胜</div>
        </div>
        <div class="score-item">
          <div class="round text-center color-white" :style="rankStyle(item)">{{ item.tieRound }}</div>
          <div>平</div>
        </div>
        <div class="score-item">
          <div class="round text-center color-white" :style="rankStyle(item)">{{ item.loseRound }}</div>
          <div>负</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { QNImageUtil } from '@/utils'
import NewMatchDetail from '@/tbs/model/to/NewMatchDetail'

const RANK_BG = {
  1: '#F7C027',
  2: '#D4D3D3',
  3: '#DCBFA8'
}

export default {
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      locale: new NewMatchDetail
    }
  },
  methods: {
    imgView(img) {
      return QNImageUtil.imageView(img)
    },
    rankLabel(item) {
      const r = item && item.finalRank
      if (r === 1) return this.locale.localeProp('rank-champion')
      if (r === 2) return this.locale.localeProp('rank-runner-up')
      if (r === 3) return this.locale.localeProp('rank-third')
      return r != null ? String(r) : ''
    },
    rankStyle(item) {
      const r = item && item.finalRank
      const bg = (r === 1 || r === 2 || r === 3) ? RANK_BG[r] : ''
      return bg ? { background: bg } : {}
    }
  }
}
</script>
<style src="@/tbs/stylesheet/dynamic.css" />
<style scoped lang="scss">
.score-announcement {
  overflow-x: scroll;
  white-space: nowrap;
  align-items: center;
  .item {
    display: inline-block;
    width: 164px;
    min-width: 164px;
    height: 130px;
    border-radius: 4px;
    padding: 0 6px;
    margin-right: 12px;
    &:last-child { margin-right: 0; }
    .rank {
      width: 55px;
      height: 20px;
      margin: 0 auto;
      border-radius: 0 0 4px 4px;
      font-size: 12px;
      font-weight: bold;
      line-height: 20px;
    }
    .team {
      margin-top: 12px;
      font-size: 14px;
      img {
        width: 22px;
        height: 22px;
        border-radius: 50%;
        margin-right: 3px;
      }
    }
    .score {
      margin-top: 12px;
      justify-content: space-around;
      .score-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 11px;
        .round {
          width: 27px;
          height: 27px;
          line-height: 27px;
          font-size: 16px;
          font-weight: 500;
          border-radius: 50%;
          margin-bottom: 6px;
        }
      }
    }
  }
}
</style>
